import { FieldNamesMarkedBoolean, FieldValues } from "react-hook-form";

export const pickDirtyValues = <T extends FieldValues>(
  values: T,
  dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<T>>>,
): Partial<T> =>
  Object.fromEntries(
    Object.entries(values).filter(
      ([key]) => dirtyFields[key as keyof typeof dirtyFields],
    ),
  ) as Partial<T>;
